<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
    <div class="div_loading">
      <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
      </div>
    </div>
    صدور پیش فاکتور
    <span class="close" (click)="close()">
      <mat-icon>close</mat-icon>
    </span>
  </div>

</div>


<div mat-dialog-content class="matDialogContent" style="min-height: 73vh;">
  <!-- 
task == 2 // برای ورودی های جدید
task == 3 // برای تایید های من
task == 4 // برای در جریان
task == 5 // همه درخواست ها  
task == 6 // همه  زباله   
<div class="my-container" [hidden]="!loading"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
<!-- ************************************************************************************************************************************************ -->

  <form #f="ngForm">
    <div class="row">
      <table class='list-table table table-hover table-bordered table-condensed table-responsive table-striped'
        [ngStyle]="lang == 2 && {direction:'ltr '}">
        <tr>
          <th>وزن تقریبی سازه دمونتاژ kg/m<sup>2</sup></th>
          <th>وزن کل تقریبی سازه دمونتاژ kg</th>
          <th>هزینه طراحی سازه m<sup>2</sup> به تومان </th>
          <th>هزینه کل طراحی سازه به تومان</th>
          <th *ngIf="product == 1 || product == 4 || product == 2">هزینه سازه به m<sup>2</sup></th>
          <th *ngIf="product == 1 || product == 4 || product == 2">قیمت کل سازه درب کارخانه به تومان</th>
          <th *ngIf="product == 1 || product == 4 || product == 2">هزینه پیچ به تومان</th>
          <th *ngIf="product == 1 || product == 4">هزینه نصب kg به تومان</th>
          <th *ngIf="product == 1 || product == 4">هزینه نصب m<sup>2</sup> به تومان </th>
          <th *ngIf="product == 1 || product == 4" colspan=2>هزینه کل نصب به تومان</th>
        </tr>
        <tr>
          <td (click)="open_weight_modal()" title="weight2">{{ weight | number }}</td>
          <td (click)="open_mv_modal()" style='cursor:pointer' title="mv">{{ mv | number }}</td>
          <td title="design">{{ design | number }}</td>
          <td (click)="open_design_modal()" style='cursor:pointer' title="design_all">{{ design_all | number }}</td>
          <td (click)="open_modal_mwf2()" style='cursor:pointer' *ngIf="product == 1 || product == 4 || product == 2"
            title="mwf2">
            {{ mwf2 | number }}</td>
          <td (click)="open_modal_mwf()" *ngIf="product == 1 || product == 4 || product == 2" style="cursor:pointer"
            title="mwf">
            {{ mwf | number }}</td>
          <td (click)="open_price_lsf()" style='cursor:pointer' *ngIf="product == 1 || product == 4 || product == 2"
            title="price_lsf">
            {{ price_lsf | number }}</td>
          <td (click)="open_fs()" style='cursor:pointer' *ngIf="product == 1 || product == 4" title="install">{{ install
            |
            number }}</td>
          <td (click)="open_install1()" style='cursor:pointer' *ngIf="product == 1 || product == 4" title="install1">
            {{ install1 | number }}</td>
          <td (click)="open_install2()" style='cursor:pointer' *ngIf="product == 1 || product == 4" colspan=2
            title="install2">
            {{ install2 | number }}</td>
        </tr>

        <tr>
          <th *ngIf="product == 1 || product == 4 || product == 2">قیمت کل به m<sup>2</sup></th>
          <th *ngIf="product == 1 || product == 4 || product == 2">ضایعات<sup>به تومان</sup></th>
          <th>قیمت کل بدون تخفیف</th>
          <th>قیمت کل با تخفیف</th>
          <th> قیمت متر مربع با تخفیف به تومان </th>
          <th>مالیات بر ارزش افزوده</th>
          <th>قیمت تقریبی کل</th>
          <th>صورتحساب فروش کالا</th>
          <th>صورتحساب خدمات</th>
        </tr>

        <tr>
          <td (click)="open_price_all1()" style='cursor:pointer' *ngIf="product == 1 || product == 4 || product == 2"
            title="price_all1">
            {{ price_all1 | number }}</td>
          <td style='cursor:pointer' *ngIf="product == 1 || product == 4 || product == 2" title="west">{{ wast | number
            }}
          </td>
          <td (click)="open_price_all_without_discount()" style='cursor:pointer' title="price_all_without_discount">{{
            price_all_without_discount | number }}
          </td>


          <td (click)="open_price_all()" style='cursor:pointer' title='price_all'>{{ price_all | number }}</td>
          <td (click)="open_price_all_m()" style='cursor:pointer' title="price_all_m2">{{
            ConvertToRound(price_all/bana_all) | number }}</td>
          <td title="percent">{{ percent | number }}</td>
          <td title="price_final">{{ price_final | number }}</td>
          <td (click)="open_modal_factor2()" style='cursor:pointer'>{{ price_factor2_final | number }}</td>
          <td (click)="open_modal_factor3()" style='cursor:pointer'>{{ price_factor3_final | number }}</td>
        </tr>
      </table>
    </div>

    <div>
      <div>

        <div class='row'>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="title" class='wh-label' title="tip"> نوع طراحی سازه :
              <select class="wh-input" id='tip' name='tip' [(ngModel)]="tip" (change)="change_items(f,2);change_tip()"
                autocomplete="off">
                <option value=0></option>
                <option *ngFor="let tip of list_tip" value='{{ tip.shop_tip_id }}'>{{ tip.shop_tip_title }}</option>
              </select>
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="title" class='wh-label' title="floor"> نوع ساحتمان :
              <select class="wh-input" name='floor' id="floor" (change)="change_floor($event)">
                <option value=0></option>
                <option *ngFor="let floor of list_floor"
                  value='{{ floor.shop_shop_floor_id }},{{ floor.shop_shop_floor_price }},{{ floor.shop_shop_floor_number }}'
                  [selected]=" floor.shop_shop_floor_id == default_floor ">{{ floor.shop_shop_floor_title }}</option>
              </select>
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="title" class='wh-label' title="crater_a"> دهانه ساختمان m :
              <select class="wh-input" id='crater_a' name='crater_a' [(ngModel)]="crater_a"
                (change)="change_crater_a($event)">
                <option value=0></option>
                <option *ngFor="let crater_a of list_crater_a_temp" value='{{ crater_a.shop_crater_id }}'>
                  {{ crater_a.shop_crater_title }}</option>
              </select>
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="title" class='wh-label' title="type_ceil"> نوع سقف آخر :
              <select class="wh-input" name='select_weight' id="select_weight" [ngClass]="{warning_form:select_weight}"
                (change)="change_items(f,1)" [disabled]="select_weight_status">
                <option value="0,0,1"></option>
                <option value='1,{{ weight1 }},{{ price1 }}' *ngIf="price1 != 0" [selected]=" type_ceil == 1 ">صاف
                </option>
                <option value='2,{{ weight2 }},{{ price2 }}' [selected]=" type_ceil == 2 ">شیبدار</option>
              </select>
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="meter" class='wh-label' title="bana_all"> زیر بنای کل m<sup>2</sup> :
              <input class='wh-input' name='bana_all' [(ngModel)]='bana_all' (keyup)="change_items(f,1)"
                autocomplete="off">
            </label>
          </div>


          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="meter" class='wh-label' title="design"> هزینه طراحی سازه m<sup>2</sup> به تومان :
              <input class='wh-input' name='design' [(ngModel)]='design' (keyup)="change_items(f,2)" readonly
                autocomplete="off">
            </label>
          </div>
        </div>

        <div>
          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding'
            *ngIf="lang == 1 && (product  == 1 || product == 4 || product == 3)">
            <label for="title" class='wh-label' title="position"> موقعیت اجرا :
              <select class="wh-input" name='position' id='position' (change)="change_items(f,2)">
                <option value='0,1'></option>
                <option *ngFor="let x of list_position"
                  value='{{ x.shop_install_run_position_id }},{{ x.shop_install_run_position_price }}'
                  [selected]="x.shop_install_run_position_id == position">{{ x.shop_install_run_position_title }}
                </option>
              </select>
            </label>
          </div>


          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding'
            *ngIf="lang == 1 && product == 1 || product == 4">
            <label for="site" class='wh-label' title="site"> امکانات سایت :
              <select class="wh-input" name="site" id="site" (change)="change_items(f,2)">
                <option value='0,1'></option>
                <option *ngFor="let x of list_site" value='{{ x.shop_install_site_id }},{{ x.shop_install_site_price }}'
                  [selected]="x.shop_install_site_id == site">{{ x.shop_install_site_title }}</option>
              </select>
            </label>
          </div>


          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="open_crater" class='wh-label' title="open_crater"> حداکثر دهانه بازشو m :
              <select class="wh-input" name='open_crater' id="open_crater" (change)="change_items(f,2)">
                <option value='0,1'></option>
                <option *ngFor="let x of list_open_crater"
                  value='{{ x.shop_install_open_crater_id }},{{ x.shop_install_open_crater_price }}'
                  [selected]="x.shop_install_open_crater_id == open_crater">{{ x.shop_install_open_crater_title }}
                </option>
              </select>
            </label>
          </div>


          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="height" class='wh-label' title="height"> ارتفاع طبقات m :
              <select class="wh-input" name='height' id="height" (change)="change_items(f,2)">
                <option value="0,1,3"></option>
                <option *ngFor="let x of list_height"
                  value='{{ x.shop_install_height_id }},{{ x.shop_install_height_price }},{{ x.shop_install_height_height }}'
                  [selected]="x.shop_install_height_id == height">{{ x.shop_install_height_title }}</option>
              </select>
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding'
            *ngIf="product == 1 || product == 4">
            <label for="title" class='wh-label' title="place"> مکان نصب :
              <select class="wh-input" name='place' id="place" (change)="change_items(f,2)">
                <option value="0,1"></option>
                <option *ngFor="let x of list_place"
                  value='{{ x.shop_install_place_id }},{{ x.shop_install_place_price }}'
                  [selected]="x.shop_install_place_id == place">{{ x.shop_install_place_title }}</option>
              </select>
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding'
            *ngIf="lang == 1 && (product == 1 || product == 4 || product == 2)">
            <label for="meter" class='wh-label' title="price"> هزینه سازه 1KG تومان :
              <input class='wh-input' name='price' [(ngModel)]='price' currencyMask (keyup)="change_items(f,1)"
                autocomplete="off">
            </label>
          </div>
        </div>

        <div class="row">
          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="discount" class='wh-label' title="discount"> تخفیف به تومان :
              <input class='wh-input' name='discount' [(ngModel)]='discount' currencyMask
                [disabled]="discount_festival > 0" (click)="open_modal_discount()" (keyup)="change_items(f,1)"
                autocomplete="off">
            </label>
          </div>


          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="discount" class='wh-label' title="discount_festival"> تخفیف جشنواره :
              <input class='wh-input' name='discount_festival' [(ngModel)]='discount_festival' currencyMask
                (keyup)="change_items(f,1)" autocomplete="off" [disabled]="discount > 0">
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1" [hidden]='true'>
            <label for="hard" class='wh-label' title="hard"> سختی کار به تومان :
              <input class='wh-input' name='hard' [(ngModel)]='hard' (keyup)="change_items(f,1)" autocomplete="off">
            </label>
          </div>


          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="arch2" class='wh-label' title="arch1">
              <span *ngIf="product == 1 || product == 4 || product == 2">هزینه معماری فاز 1 :</span>
              <span *ngIf="product == 3"> طراحی معماری فاز 1 :</span>
              <input class='wh-input' name='arch1' [(ngModel)]='arch1' currencyMask (keyup)="change_items(f,1)"
                autocomplete="off">
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="arch2" class='wh-label' title="arch2">
              <span *ngIf="product == 1 || product == 4 || product == 2">هزینه معماری فاز 2 :</span>
              <span *ngIf="product == 3"> طراحی معماری فاز 2 :</span>
              <input class='wh-input' name='arch2' [(ngModel)]='arch2' currencyMask (keyup)="change_items(f,1)"
                autocomplete="off">
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1 ">
            <span class="add_user" (click)="add_user()"><i class="fas fa-bookmark cursor"></i></span>

            <label for="title" class='wh-label' title="requester_title"> درخواست کننده :
              <input class='wh-input' name='requester_title' [(ngModel)]='requester_title'
                (click)="select_requester_title(1)" readonly>
              <input class='wh-input' name='requester_id' [(ngModel)]='requester_id' (click)="select_requester_title(1)"
                readonly [hidden]="true">
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding'
            *ngIf="lang == 1 && (product == 1 || product == 4 || product == 2)">
            <label for="title" class='wh-label' title="bullet"> پیچ :
              <select class="wh-input" name='bullet' [(ngModel)]="bullet" (change)="change_items(f,1)">
                <option value=0></option>
                <option value=1>باشد</option>
                <option value=2>نباشد</option>
              </select>
            </label>
          </div>
        </div><!-- row -->

        <div class="row">
          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="title" class='wh-label'> ارزش افزوده :
              <select class="wh-input" name='tax_check_value' [(ngModel)]="tax_check_value"
                (change)="change_items(f,1)">
                <option value=0></option>
                <option value=2>باشد</option>
                <option value=1>نباشد</option>
              </select>
            </label>
          </div>

          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding'
            *ngIf="lang == 1  && (product == 1 || product == 4 || product == 2)">
            <label for="address" class='wh-label'> ضایعات :
              <input class='wh-input' name='wast' (click)="open_modal_wast()" [(ngModel)]='wast' autocomplete="off"
                readonly>
            </label>
          </div>

          <div class='col-md-4 pe div_panding' *ngIf="lang == 1">
            <label for="address" class='wh-label'> آدرس :
              <input class='wh-input' name='address' [(ngModel)]='address' autocomplete="off">
            </label>
          </div>


          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding'>
            <label for="title" class='wh-label' title="tip"> وضعیت :
              <select class="wh-input" name='status_id' [(ngModel)]="status_id" autocomplete="off">
                <option value=0></option>
                <option *ngFor="let status of list_status" value='{{ status.sale_process_id }}'>{{
                  status.sale_process_title }}</option>
              </select>
            </label>
          </div>


          <div class='col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12  pe div_panding' *ngIf="lang == 1">
            <label for="comment" class='wh-label'> توضیحات :
              <input class='wh-input' name='comment' [(ngModel)]='comment' autocomplete="off">
            </label>
          </div>
        </div><!-- row -->
      </div>
    </div>

    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #modal_wast identifier="modal_wast" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> محاسبه ضایعات </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>
      <div class='row' style='border-bottom:solid #666 '>
        <div class='col-md-6 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> وزن ضایعات به کیلو گرم :
            <input class='wh-input' name='wast_weight' [(ngModel)]='wast_weight' (keyup)="change_items(f,1)">
          </label>
        </div>

        <div class='col-md-6 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> قیمت هر کیلو گرم :
            <input class='wh-input' name='wast_price' [(ngModel)]='wast_price' (keyup)="change_items(f,1)">
          </label>
        </div>

      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #modal_contract identifier="modal_contract" [customClass]="'medium-modal'" class="pe print"
      [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
      <div class='col-md-12 pe header' style='text-align:center'>
        قرارداد
      </div>
      <textarea class='wh-input1' style='height:31rem;padding:31px;width:100%;font-family:irsans2;font-size: 0.75rem;'
        name='contract' [(ngModel)]='contract'>
  {{ contract  }}
 </textarea>
    </ngx-smart-modal>


    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #fs identifier="fs" class="pe" [customClass]="'medium-modal'" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> محاسبه FS </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>
      <div class='row'>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f1" class='wh-label'> --- :
            <input class='wh-input' name='f1' [(ngModel)]='f1' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f1" class='wh-label'> ضریب هزینه نصب تعداد طبقات :
            <input class='wh-input' name='f1' [(ngModel)]='f1' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f1_diff" class='wh-label'> --- :
            <input class='wh-input' name='f1_diff' [(ngModel)]='f1_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f1_diff" class='wh-label'> ما به تفاوت ضریب هزینه نصب تعداد طبقات :
            <input class='wh-input' name='f1_diff' [(ngModel)]='f1_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>


        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install2_diff" class='wh-label'> --- :
            <input class='f2-input' name='f2' [(ngModel)]='f2' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f2" class='wh-label'> ضریب هزینه نوع سقف آخر :
            <input class='wh-input' name='f2' [(ngModel)]='f2' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f2_diff" class='wh-label'> --- :
            <input class='wh-input' name='f2_diff' [(ngModel)]='f2_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f2_diff" class='wh-label'> ما به تفاوت ضریب هزینه نوع سقف آخر :
            <input class='wh-input' name='f2_diff' [(ngModel)]='f2_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>


        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f3" class='wh-label'> --- :
            <input class='wh-input' name='f3' [(ngModel)]='f3' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f3" class='wh-label'> ضریب هزینه طراحی سازه m<sup>2</sup> :
            <input class='wh-input' name='f3' [(ngModel)]='f3' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f3_diff" class='wh-label'> --- :
            <input class='wh-input' name='f3_diff' [(ngModel)]='f3_diff' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f3_diff" class='wh-label'> ضریب هزینه طراحی سازه m<sup>2</sup>ما به تفاوت :
            <input class='wh-input' name='f3_diff' [(ngModel)]='f3_diff' [disabled]="true" style='background:#ccc'>
          </label>
        </div>



        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install2_diff" class='wh-label'> --- :
            <input class='wh-input' name='f4' [(ngModel)]='f4' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="install2_diff" class='wh-label'> ضریب هزینه موقعیت اجرا :
            <input class='wh-input' name='f4' [(ngModel)]='f4' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f4_diff" class='wh-label'> --- :
            <input class='wh-input' name='f4_diff' [(ngModel)]='f4_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f4_diff" class='wh-label'> ما به تفاوت ضریب هزینه موقعیت اجرا :
            <input class='wh-input' name='f4_diff' [(ngModel)]='f4_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f5" class='wh-label'> --- :
            <input class='wh-input' name='f5' [(ngModel)]='f5' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f5" class='wh-label'> ضریب هزینه امکانات سایت :
            <input class='wh-input' name='f5' [(ngModel)]='f5' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f5_diff" class='wh-label'> --- :
            <input class='wh-input' name='f5_diff' [(ngModel)]='f5_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f5_diff" class='wh-label'> ما به تفاوت ضریب هزینه امکانات سایت :
            <input class='wh-input' name='f5_diff' [(ngModel)]='f5_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f6" class='wh-label'> --- :
            <input class='wh-input' name='f6' [(ngModel)]='f6' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f6" class='wh-label'> ضریب هزینه حداکثر دهانه بازشو :
            <input class='wh-input' name='f6' [(ngModel)]='f6' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f6_diff" class='wh-label'> --- :
            <input class='wh-input' name='f6_diff' [(ngModel)]='f6_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f6_diff" class='wh-label'> ما به تفاوت ضریب هزینه حداکثر دهانه بازشو :
            <input class='wh-input' name='f6_diff' [(ngModel)]='f6_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f7" class='wh-label'> --- :
            <input class='wh-input' name='f7' [(ngModel)]='f7' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f7" class='wh-label'> ضریب هزینه ارتفاع طبقات :
            <input class='wh-input' name='f7' [(ngModel)]='f7' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f7_diff" class='wh-label'> --- :
            <input class='wh-input' name='f7_diff' [(ngModel)]='f7_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f7_diff" class='wh-label'> ما به تفاوت ضریب هزینه ارتفاع طبقات :
            <input class='wh-input' name='f7_diff' [(ngModel)]='f7_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f8" class='wh-label'> --- :
            <input class='wh-input' name='f8' [(ngModel)]='f8' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f8" class='wh-label'> ضریب هزینه محل نصب :
            <input class='wh-input' name='f8' [(ngModel)]='f8' [disabled]="true" style='background:#ccc'>
          </label>
        </div>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="f8_diff" class='wh-label'> --- :
            <input class='wh-input' name='f8_diff' [(ngModel)]='f8_diff' (keyup)="change_items(f,1)">
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="f8_diff" class='wh-label'> ما به تفاوت ضریب هزینه محل نصب :
            <input class='wh-input' name='f8_diff' [(ngModel)]='f8_diff' (keyup)="change_items(f,1)" [disabled]="true"
              style='background:#ccc'>
          </label>
        </div>

      </div>

      <div class='col-md-3 en' *ngIf="lang == 2">
        <label for="install_diff" class='wh-label'> --- :
          <input class='wh-input' name='install_diff' [(ngModel)]='install_diff' (keyup)="change_items(f,1)">
        </label>
      </div>
      <div class='col-md-3 pe' *ngIf="lang == 1">
        <label for="install_diff" class='wh-label'> ما به تفاوت هزینه نصب KG تومان:
          <input class='wh-input' name='install_diff' [(ngModel)]='install_diff' (keyup)="change_items(f,1)"
            autocomplete="off">
        </label>
      </div>

      <div class='col-md-12 en' *ngIf="lang == 2">
        <span style='float:right'> هزینه نصب kg به تومان </span>
        <span style='background:yellow'> {{ install | number }} </span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        <span style='float:right'> هزینه نصب kg به تومان </span>
        <span style='background:yellow'> {{ install | number }} </span>
      </div>


    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #install1_modal identifier="install1_modal" class="pe" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> هزینه نصب به m<sup>2</sup> به تومان </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>

      <div class='col-md-6 en' *ngIf="lang == 2">
        <label for="install1_diff" class='wh-label'> --- :
          <input class='wh-input' name='install1_diff' [(ngModel)]='install1_diff' (keyup)="change_items(f,1)">
        </label>
      </div>
      <div class='col-md-6 pe' *ngIf="lang == 1">
        <label for="install1_diff" class='wh-label'> ما به تفاوت هزینه نصب m<sup>2</sup>تومان :
          <input class='wh-input' name='install1_diff' [(ngModel)]='install1_diff' (keyup)="change_items(f,1)">
        </label>
      </div>
      <div class='col-md-12 pe'>
        <span style='float:right'> هزینه نصب kg به تومان : </span>
        <span style='background:yellow'> {{ install | number }} </span>
      </div>
      <div class='col-md-12 pe'>
        <span style='float:right'> وزن تقریبی سازه دمونتاژ به کیلوگرم بر مترمربع(*) :</span>
        <span style='background:yellow'> {{ weight | number }} </span>
      </div>
      <div class='col-md-12 pe'>
        <span style='float:right'> مابه تفاوت هزینه نصب به مترمربع(+) :</span>
        <span style='background:yellow'> {{ install1_diff | number }} </span>
      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #install2_modal identifier="install2_modal" class="pe" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> هزینه کل نصب به تومان </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>

      <div class='col-md-6 en' *ngIf="lang == 2">
        <label for="install1_diff" class='wh-label'> --- :
          <input class='wh-input' name='install2_diff' [(ngModel)]='install2_diff' (keyup)="change_items(f,1)">
        </label>
      </div>
      <div class='col-md-6 pe' *ngIf="lang == 1">
        <label for="install1_diff" class='wh-label'> ما به تفاوت هزینه کل نصب به تومان :
          <input class='wh-input' name='install2_diff' [(ngModel)]='install2_diff' (keyup)="change_items(f,1)">
        </label>
      </div>
      <div class='col-md-12 pe'>
        <span style='float:right'> هزینه نصب کیلو گرم به تومان: </span>
        <span style='background:yellow'> {{ install | number }} </span>
      </div>
      <div class='col-md-12 pe'>
        <span style='float:right'> وزن کل تقریبی سازه دمونتاژ به کیلوگرم (*): </span>
        <span style='background:yellow'> {{ mv | number }} </span>
      </div>
      <div class='col-md-12 pe'>
        <span style='float:right'> ما به تفاوت هزینه کل نصب به تومان (+): </span>
        <span style='background:yellow'> {{ install2_diff | number }} </span>
      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #price_all_without_discount_modal identifier="price_all_without_discount_modal" class="pe"
      [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> قیمت کل بدون تخفیف </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>
      <div class='col-md-12 en' *ngIf="lang == 2">

      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        قیمت کل سازه درب کارخانه به تومان : <span style="background:yellow">{{ mwf | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="product == 1 || product == 4 || product == 2">
        هزینه پیچ به تومان : <span style="background:yellow"> {{ price_lsf | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="product == 1 || product == 4">
        هزینه کل نصب به تومان : <span style="background:yellow"> {{ install2 | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه کل طراحی سازه به تومان : <span style="background:yellow"> {{ design_all | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه معماری فاز 1 به تومان <span style="background:yellow"> {{ arch1 | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه معماری فاز 2 به تومان <span style="background:yellow"> {{ arch2 | number }}
        </span>
      </div>
    </ngx-smart-modal>

    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #price_all_m_modal identifier="price_all_m_modal" class="pe" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> قیمت متر مربع با تخفیف به تومان </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>
      <div class='col-md-12 en' *ngIf="lang == 2">

      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        قیمت کل با تخفیف به تومان : <span style="background:yellow">{{ price_all | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        زیر بنای کل : <span style="background:yellow"> {{ bana_all| number }}</span>
      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #price_all1_modal identifier="price_all1_modal" class="pe" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> قیمت کل به m<sup>2</sup> </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>
      <div class='col-md-12 en' *ngIf="lang == 2">

      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        قیمت کل سازه درب کارخانه به تومان : <span style="background:yellow">{{ mwf | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="product == 1 || product == 4 || product == 2">
        هزینه پیچ به تومان : <span style="background:yellow"> {{ price_lsf | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="product == 1 || product == 4">
        هزینه کل نصب به تومان : <span style="background:yellow"> {{ install2 | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه کل طراحی سازه به تومان : <span style="background:yellow"> {{ design_all | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه معماری فاز 1 به تومان <span style="background:yellow"> {{ arch1 | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه معماری فاز 2 به تومان <span style="background:yellow"> {{ arch2 | number }}
        </span> </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        (-) تخفیف به تومان : <span style="background:yellow"> {{ discount | number }}
        </span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        (-) تخفیف جشنواره به تومان : <span style="background:yellow"> {{ discount_festival_price | number }}
        </span>
      </div>
      <hr />
      <div class='col-md-12 pe' *ngIf="lang == 1">
        (/) زیر بنای کل : <span style="background:yellow"> {{ bana_all | number }} </span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 2">
        <span style="background:yellow"> {{ bana_all | number }} </span>
      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #price_all_modal identifier="price_all_modal" class="pe" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> قیمت کل با تخفیف به تومان </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        قیمت کل سازه درب کارخانه به تومان : <span style="background:yellow">{{ mwf | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="product == 1 || product == 4 || product == 2">
        هزینه پیچ به تومان : <span style="background:yellow"> {{ price_lsf | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="product == 1 || product == 4">
        هزینه کل نصب به تومان : <span style="background:yellow"> {{ install2 | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه کل طراحی سازه به تومان : <span style="background:yellow"> {{ design_all | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه معماری فاز 1 به تومان <span style="background:yellow"> {{ arch1 | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه معماری فاز 2 به تومان <span style="background:yellow"> {{ arch2 | number }}
        </span> </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        ضایعات <span style="background:yellow"> {{ wast | number }} </span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        (-) تخفیف به تومان : <span style="background:yellow"> {{ discount | number }}
        </span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        (-) تخفیف جشنواره به تومان : <span style="background:yellow"> {{ discount_festival_price | number }}
        </span>
      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #modal_factor2 identifier="modal_factor2" class="pe" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> صورتحساب فروش کالا </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        قیمت کل سازه درب کارخانه به تومان : <span style="background:yellow">{{ mwf | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="product == 1 || product == 4 || product == 2">
        هزینه پیچ به تومان : <span style="background:yellow"> {{ price_lsf | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        صورتحساب فروش کالا بدون تخفیف :
        <span style="background:yellow"> {{ price_factor2 | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        (-) تخفیف به تومان :
        <span style="background:yellow"> {{ price_factor2_discount | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        صورتحساب فروش کالا با تخفیف :
        <span style="background:yellow"> {{ price_factor2_with_discount | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        (+) ارزش افزوده :
        <span style="background:yellow"> {{ price_factor2_tax | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        صورتحساب فروش کالا با حتساب ارزش افزوده :
        <span style="background:yellow">{{ price_factor2_final | number }}</span>
      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #modal_factor3 identifier="modal_factor3" class="pe" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> صورتحساب خدمات </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>

      <div class='col-md-12 pe' *ngIf="product == 1 || product == 4">
        هزینه کل نصب به تومان : <span style="background:yellow"> {{ install2 | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه کل طراحی سازه به تومان : <span style="background:yellow"> {{ design_all | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه معماری فاز 1 به تومان <span style="background:yellow"> {{ arch1 | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        هزینه معماری فاز 2 به تومان <span style="background:yellow"> {{ arch2 | number }}
        </span>
      </div>

      <div class='col-md-12 pe' *ngIf="lang == 1">
        صورتحساب فروش کالا بدون تخفیف :
        <span style="background:yellow"> {{ price_factor3 | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        (-) تخفیف مدیریتی به تومان :
        <span style="background:yellow"> {{ price_factor3_discount | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        صورتحساب فروش کالا با تخفیف :
        <span style="background:yellow"> {{ price_factor3_with_discount | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        (+) ارزش افزوده :
        <span style="background:yellow"> {{ price_factor3_tax | number }}</span>
      </div>
      <div class='col-md-12 pe' *ngIf="lang == 1">
        صورتحساب فروش کالا با حتساب ارزش افزوده :
        <span style="background:yellow">{{ price_factor3_final | number }}</span>
      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #modal_discount identifier="modal_discount" class="pe" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> محاسبه تخفیف </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>
      <div class='row' style='border-bottom:solid #666 '>
        <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> تخفیف طراحی سازه :
            <input class='wh-input' name='discount_design_all' (keyup)="change_items(f,1)" currencyMask
              [(ngModel)]='discount_design_all'>
          </label>
        </div>

        <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> تخفیف پیچ سازه :
            <input class='wh-input' name='discount_price_lsf1' (keyup)="change_items(f,1)" currencyMask
              [(ngModel)]='discount_price_lsf1'>
          </label>
        </div>

        <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> تخفیف پیچ بکس :
            <input class='wh-input' name='discount_price_lsf2' (keyup)="change_items(f,1)" currencyMask
              [(ngModel)]='discount_price_lsf2'>
          </label>
        </div>

        <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> تخفیف رول بلت :
            <input class='wh-input' name='discount_price_lsf3' (keyup)="change_items(f,1)" currencyMask
              [(ngModel)]='discount_price_lsf3'>
          </label>
        </div>


        <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> تخفیف سازه LSF :
            <input class='wh-input' name='discount_mwf' (keyup)="change_items(f,1)" currencyMask
              [(ngModel)]='discount_mwf'>
          </label>
        </div>

        <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> تخفیف هزینه نصب :
            <input class='wh-input' name='discount_install2' (keyup)="change_items(f,1)" currencyMask
              [(ngModel)]='discount_install2'>
          </label>
        </div>

        <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe' *ngIf="lang == 1" [hidden]="true">
          <label for="install_diff" class='wh-label'> تخفیف کل :
            <input class='wh-input' name='discount_all' (keyup)="change_items(f,1)" currencyMask
              [(ngModel)]='discount_all' readonly disabled>
          </label>
        </div>

      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #price_lsf_modal identifier="price_lsf_modal" [customClass]="'medium-modal'" class="pe"
      [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> محاسبه هزینه پیچ </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>
      <div class='row' style='border-bottom:solid #666 '>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install_diff" class='wh-label'> --- :
            <input class='wh-input' name='price_lsf1_number' [(ngModel)]='price_lsf1_number' [disabled]='true'
              style='background-color:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> تعداد پیچ سازه :
            <input class='wh-input' name='price_lsf1_number' [(ngModel)]='price_lsf1_number' [disabled]='true'
              style='background-color:#ccc'>
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="price_lsf1_number_diff" class='wh-label'> --- :
            <input class='wh-input' name='price_lsf1_number_diff' [(ngModel)]='price_lsf1_number_diff'
              (keyup)="change_items(f,1)">
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="price_lsf1_number_diff" class='wh-label'> ما به تفاوت تعداد پیچ سازه :
            <input class='wh-input' name='price_lsf1_number_diff' [(ngModel)]='price_lsf1_number_diff'
              (keyup)="change_items(f,1)" autocomplete="off">
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install_diff" class='wh-label'> --- :
            <input class='wh-input' name='price_lsf1' [(ngModel)]='price_lsf1' (keyup)="change_items(f,1)"
              autocomplete="off">
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> قیمت واحد پیچ سازه :
            <input class='wh-input' name='price_lsf1' [(ngModel)]='price_lsf1' (keyup)="change_items(f,1)"
              autocomplete="off">
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install_diff" class='wh-label'> --- :
            <input class='wh-input' name='price_lsf1_price' [(ngModel)]='price_lsf1_price'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> قیمت کل پیچ سازه :
            <input class='wh-input' name='price_lsf1_price' [(ngModel)]='price_lsf1_price' [disabled]='true'>
          </label>
        </div>
      </div><!-- row -->

      <div class='row' style='border-bottom:solid #666 '>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install_diff" class='wh-price_lsf2_number'> --- :
            <input class='wh-input' name='price_lsf1_number' [(ngModel)]='price_lsf2_number' [disabled]='true'
              style='background-color:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> تعداد بکس :
            <input class='wh-input' name='price_lsf2_number' [(ngModel)]='price_lsf2_number' [disabled]='true'
              style='background-color:#ccc'>
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="price_lsf2_number_diff" class='wh-label'> --- :
            <input class='wh-input' name='price_lsf2_number_diff' [(ngModel)]='price_lsf2_number_diff'
              (keyup)="change_items(f,1)">
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="price_lsf2_number_diff" class='wh-label'> ما به تفاوت تعداد بکس :
            <input class='wh-input' name='price_lsf2_number_diff' [(ngModel)]='price_lsf2_number_diff'
              (keyup)="change_items(f,1)" autocomplete="off">
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install_diff" class='wh-price_lsf2_number'> --- :
            <input class='wh-input' name='price_lsf2_price' [(ngModel)]='price_lsf2_price'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> قیمت واحد پیچ بکس :
            <input class='wh-input' name='price_lsf2' [(ngModel)]='price_lsf2' (keyup)="change_items(f,1)"
              autocomplete="off">
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install_diff" class='wh-price_lsf2_number'> --- :
            <input class='wh-input' name='price_lsf2' [(ngModel)]='price_lsf2' (keyup)="change_items(f,1)"
              autocomplete="off">
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> قیمت کل پیچ بکس :
            <input class='wh-input' name='price_lsf2_price' [(ngModel)]='price_lsf2_price' [disabled]='true'>
          </label>
        </div>
      </div><!-- end row -->

      <div class='row'>
        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install_diff" class='wh-price_lsf2_number'> --- :
            <input class='wh-input' name='price_lsf3_number' [(ngModel)]='price_lsf3_number' [disabled]='true'
              style='background-color:#ccc'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> تعداد رول بلت :
            <input class='wh-input' name='price_lsf3_number' [(ngModel)]='price_lsf3_number' [disabled]='true'
              style='background-color:#ccc'>
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="price_lsf3_number_diff" class='wh-label'> --- :
            <input class='wh-input' name='price_lsf3_number_diff' [(ngModel)]='price_lsf3_number_diff'
              (keyup)="change_items(f,1)">
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="price_lsf3_number_diff" class='wh-label'> ما به تفاوت تعداد رول بلت :
            <input class='wh-input' name='price_lsf3_number_diff' [(ngModel)]='price_lsf3_number_diff'
              (keyup)="change_items(f,1)" autocomplete="off">
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install_diff" class='wh-price_lsf2_number'> --- :
            <input class='wh-input' name='price_lsf3' [(ngModel)]='price_lsf3' autocomplete="off">
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> قیمت واحد رول بلت :
            <input class='wh-input' name='price_lsf3' [(ngModel)]='price_lsf3' (keyup)="change_items(f,1)"
              autocomplete="off">
          </label>
        </div>

        <div class='col-md-3 en' *ngIf="lang == 2">
          <label for="install_diff" class='wh-price_lsf2_number'> --- :
            <input class='wh-input' name='price_lsf3_price' [(ngModel)]='price_lsf3_price'>
          </label>
        </div>
        <div class='col-md-3 pe' *ngIf="lang == 1">
          <label for="install_diff" class='wh-label'> قیمت کل رول بلت :
            <input class='wh-input' name='price_lsf3_price' [(ngModel)]='price_lsf3_price' [disabled]='true'
              (keyup)="change_items(f,1)">
          </label>
        </div>

        <div class='col-md-12 en' *ngIf="lang == 2">
          <span style='float:right'> --- </span>
          <span style='background:yellow'> {{ price_lsf | number }} </span>
        </div>
        <div class='col-md-12 pe' *ngIf="lang == 1">
          <span style='float:right'> هزینه پیچ به تومان </span>
          <span style='background:yellow'> {{ price_lsf | number }} </span>
        </div>

      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #mv_modal identifier="mv_modal" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> وزن کل تقریبی سازه دمونتاژ kg </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>

      <div class='col-md-6 en' *ngIf="lang == 2">
        <label for="weight_diff" class='wh-label'> --- :
          <input class='wh-input' name='weight_diff' [(ngModel)]='weight_diff' (keyup)="change_items(f,2)"
            autocomplete="off">
        </label>
      </div>
      <div class='col-md-6 pe' *ngIf="lang == 1">
        <label for="weight_diff" class='wh-label'> ما به تفاوت وزن کل تقریبی سازه و مونتاژ :
          <input class='wh-input' name='weight_diff' [(ngModel)]='weight_diff' (keyup)="change_items(f,2)"
            [disabled]="true" autocomplete="off">
        </label>
      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #weight_modal identifier="weight_modal" class="pe" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> وزن تقریبی سازه دمونتاژ kg </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>

      <div class='col-md-6 pe' *ngIf="lang == 1">
        <label for="weight_diff" class='wh-label'> ما به تفاوت وزن تقریبی سازه دمونتاژ kg/m<sup>2</sup>:
          <input class='wh-input' name='weight1_diff' [(ngModel)]='weight1_diff' (keyup)="change_items(f,2)"
            autocomplete="off">
        </label>
      </div>

      <div>
        <div class='col-md-12 pe' *ngIf="lang == 1" style="direction:ltr">
          وزن اولیه سازه بر حسب سقف به کیلوگرم (w) : <span style="background:yellow">{{ select_weight_weight | number
            }}</span>
        </div>
        <div class='col-md-12 pe' *ngIf="lang == 1" style="direction:ltr">
          ارتفاع طبقات به متر مربع (h) : <span style="background:yellow">{{ height_floor | number }}</span>
        </div>
        <div class='col-md-12 pe' *ngIf="lang == 1" style="direction:ltr">
          weight = w+(h-3)*5 + ما به تفاوت
        </div>
      </div>
    </ngx-smart-modal>
    <!-- ************************************************************************************************************************************************ -->
    <ngx-smart-modal #design_modal identifier="design_modal" class="pe" [ngClass]="{en:lang==2}"
      (onClose)="ModalClose()">
      <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> هزینه طراحی سازه m2 به تومان </div>
      <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> </div>

      <div class='col-md-6 en' *ngIf="lang == 2">
        <label for="weight_diff" class='wh-label'> --- :
          <input class='wh-input' name='design_diff' [(ngModel)]='design_diff' (keyup)="change_items(f,2)"
            autocomplete="off">
        </label>
      </div>
      <div class='col-md-6 pe' *ngIf="lang == 1">
        <label for="weight_diff" class='wh-label'> ما به تفاوت هزینه کل طراحی سازه :
          <input class='wh-input' name='design_diff' [(ngModel)]='design_diff' (keyup)="change_items(f,2)"
            autocomplete="off">
        </label>
      </div>
    </ngx-smart-modal>
  </form>
  <!-- ************************************************************************************************************************************************ -->
  <ngx-smart-modal #myModalSelect identifier="myModalSelect" class='pe_select' [ngClass]="{en_select:lang==2}"
    (onClose)="ModalClose()">
    <div style='padding:12px'>
      <form class="example-form" style='z-index:99999999999 !important'>
        <div class="row">
          <div class='col-xl-6 col-lg-6 col-md-6 col-md-6 col-sm-6 col-xs-12 pe' style='float:right'
            [ngClass]="{ en:lang==2 }">
            <label for="inventory_search" class='wh-label'>
              <span *ngIf="type_user == 1 "> نام خریدار:</span>
              <span *ngIf="type_user == 2 ||  type_user == 3"> نام درخواست دهنده :</span>
              <input class='wh-input' name='requester_title_search_modal'
                [(ngModel)]='requester_title_search_modal'></label>
          </div>
          <div class='col-xl-6 col-lg-6 col-md-6 col-md-6 col-sm-6 col-xs-12 pe' style='float:right'
            [ngClass]="{ en:lang==2 }">
            <label for="inventory_search" class='wh-label'>
              <span>شناسه کاربری : </span>
              <input class='wh-input' name='username_search_modal' [(ngModel)]='username_search_modal'></label>
          </div>

          <div class='col-xl-12 col-lg-12 col-md-12 col-md-12 col-sm-12 col-xs-12 en'
            style='margin-top:8px;text-align:center' [ngClass]="{ en:lang==2 }">
            <button _ngcontent-c2="" class="btn btn-success" type="button" (click)="search_new_requester()"
              style='width:100px;' *ngIf="lang == 1">جستجو</button>
            <button _ngcontent-c2="" class="btn btn-success" type="button" (click)="search_requester_reset(type_user)"
              style='width:100px;' *ngIf="lang == 1">بدون انتخاب</button>
          </div>
        </div><!-- row -->
      </form>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-md-12 col-sm-12 col-xs-12">
          <table class='table table-hover table-bordered table-condensed table-responsive table-striped'
            [ngStyle]="lang == 2 && {direction:'ltr '}">
            <tr>
              <th style='width:4% !important' *ngIf="lang == 1 "> رديف </th>
              <th style='width:4% !important' *ngIf="lang == 2 "> # </th>
              <th style='width:26% !important'> نام خریدار </th>
              <th style='width:26% !important;'> شناسه کاربری </th>
            </tr>
            <tr *ngFor='let search of list_requester;let i = index'>
              <td>{{ i+1 }}</td>
              <td *ngIf='(type == 2 || type == 1)  '
                (dblclick)="select_requester(search.user_id,search.user_title,search.user_title2,search.user_userName,search.user_cellPhone)"
                style='cursor:pointer'>{{ search.user_title }}</td>
              <td *ngIf='type == 3'
                (dblclick)="select_requester_search(search.user_id,search.user_title,search.user_title2,search.user_userName)"
                style='cursor:pointer'>{{ search.user_title }}</td>
              <td *ngIf='(type == 2 || type == 1)'
                (dblclick)="select_requester(search.user_id,search.user_title,search.user_title2,search.user_userName,search.user_cellPhone)"
                style='cursor:pointer;display:none'>{{ search.user_title2 }}</td>
              <td *ngIf='type == 3'
                (dblclick)="select_requester_search(search.user_id,search.user_title,search.user_title2,search.user_userName)"
                style='cursor:pointer;display:none'>{{ search.user_title2 }}</td>
              <td *ngIf='(type == 2 || type == 1)'
                (dblclick)="select_requester(search.user_id,search.user_title,search.user_title2,search.user_userName,search.user_cellPhone)"
                style='cursor:pointer;'>{{ search.user_userName }}</td>
              <td *ngIf='type == 3'
                (dblclick)="select_requester_search(search.user_id,search.user_title,search.user_title2,search.user_userName)"
                style='cursor:pointer;'>{{ search.user_userName }}</td>
            </tr>
          </table>
        </div>
      </div>

    </div>
  </ngx-smart-modal>
  <!-- ************************************************************************************************************************************************ -->
  <ngx-smart-modal #profile_user_modal identifier="profile_user_modal" class="pe" [ngClass]="{en:lang==2}"
    (onClose)="ModalClose()">
    <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> مشخصات خریدار </div>
    <div class='col-md-12 en' style='margin-top:0px;' *ngIf="lang == 2"> --- </div>

    <div class='col-md-12 pe' *ngIf="lang == 1">
      شناسه کاربری : <span>{{ user_username }}</span>
    </div>

    <div class='col-md-12 pe' *ngIf="lang == 1">
      نام خریدار : <span>{{ user_fname }}</span>
    </div>
    <div class='col-md-12 pe' *ngIf="lang == 1">
      شماره همراه : <span>{{ user_cellphone }}</span>
    </div>

  </ngx-smart-modal>

  <ngx-smart-modal #modal_mwf identifier="modal_mwf" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
    <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> قیمت کل سازه درب کارخانه به تومان </div>
    <div class='col-md-12 pe' *ngIf="lang == 1">
      وزن کل تقریبی سازه دمونتاژ به کیلو گرم : <span style="background:yellow">{{ mv | number }}</span>
    </div>
    <div class='col-md-12 pe' *ngIf="lang == 1">
      هزینه سازه 1KG تومان * : <span style="background:yellow">{{ price | number }}</span>
    </div>

    <div class='col-md-12 pe' *ngIf="lang == 1">
      تخفیف جشنواره : <span style="background:yellow">{{ discount_festival | number }}%</span>
    </div>
  </ngx-smart-modal>

  <ngx-smart-modal #modal_mwf2 identifier="modal_mwf2" class="pe" [ngClass]="{en:lang==2}" (onClose)="ModalClose()">
    <div class='col-md-12 pe' style='text-align:center' *ngIf="lang == 1"> محاسبه هزینه سازه به مترمربع </div>
    <div class='col-md-12 pe' *ngIf="lang == 1">
      قیمت کل سازه درب کارخانه به تومان : <span style="background:yellow">{{ mwf | number }}</span>
    </div>
    <div class='col-md-12 pe' *ngIf="lang == 1">
      زیر بنای کل به متر مربع / : <span style="background:yellow">{{ bana_all | number }}</span>
    </div>
  </ngx-smart-modal>
</div><!-- mat-diaolog-content -->


<div mat-dialog-actions class="matDialogActions" style="padding:0px !important">
  <!-- [disabled]='disable_status1'      -->
  <button class="btn_pe" (click)="print()"> پرینت </button>

  <button class='btn_pe' (click)="open_contract()">قرارداد</button>
  <button class='btn_pe' (click)="attachment()"> ضمیمه ها </button>
  <button class='btn_pe' [disabled]="true"> توضیحات </button>
  <button class='btn_pe' (click)="update(1)" [disabled]="loading" *ngIf="shop == 1">ذخیره تغییرات</button>
  <button class='btn_pe' (click)="update(2)" [disabled]="loading" *ngIf="shop == 1">ذخیره و بستن</button>
  -
  <a [href]="serverService.get_currenct_site()+'/sale-invoice/'+ id" target="_blank">
    <button class='btn_pe'> فاکتور رسمی </button>
  </a>
  <button class='btn_pe' (click)="update(3)" style="float:left"> ذخیره و ارسال </button>

  <select style="width:150px;display:inline-block;height:29px;display:none" name="document" [(ngModel)]="document"
    (change)="open_document($event)">
    <option></option>
    <option *ngFor="let x of list_forms" [value]=x.shop_forms_id> {{ x.shop_forms_title }} </option>
  </select>

</div>